import {
    useState
} from "react";
import {
    StyleSheet,
    View
} from "react-native";
import {
    BrandMark
} from "./brand";
import {
    GoogleColorBrandIcon,
    NCoreUIKitTheme,
    GitHubBrandIcon,
    AppleBrandIcon,
    Separator,
    TextInput,
    CheckBox,
    Button,
    Card,
    Text
} from "ncore-ui-kit";
import {
    useDocsI18n
} from "../i18n";
const stylesheet = StyleSheet.create({
    link: {
        textDecorationLine: "underline"
    },
    forgotRow: {
        justifyContent: "flex-end",
        flexDirection: "row"
    },
    inline: {
        justifyContent: "center",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap"
    },
    container: {
        justifyContent: "center",
        alignItems: "center",
        flexGrow: 1
    },
    column: {
        flexDirection: "column"
    },
    heading: {
        alignItems: "center"
    },
    centered: {
        textAlign: "center"
    },
    card: {
        width: "100%"
    },
    footer: {
        width: "100%"
    }
});

const Login01 = () => {
    const {
        t
    } = useDocsI18n();

    const {
        shapeConfigs,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext();

    const [
        isRemembered,
        setIsRemembered
    ] = useState(true);

    const handlePress = () => undefined;

    const handleRememberPress = () => setIsRemembered(previous => !previous);

    const renderProvider = (title: string, icon: typeof GoogleColorBrandIcon) => <Button
        spreadBehaviour="stretch"
        onPress={handlePress}
        variant="outline"
        type="neutral"
        title={title}
        icon={icon}
    />;

    return <View
        style={[
            stylesheet.container,
            {
                backgroundColor: colors.content.container.mid,
                padding: spaces.spacingLg,
                gap: spaces.spacingMd
            }
        ]}
    >
        <Card
            style={[
                stylesheet.card,
                {
                    maxWidth: shapeConfigs.cardWidth
                }
            ]}
            variant="elevated"
        >
            <Card.Header>
                <View
                    style={[
                        stylesheet.heading,
                        {
                            gap: spaces.spacingMd
                        }
                    ]}
                >
                    <BrandMark/>
                    <View
                        style={[
                            stylesheet.heading,
                            {
                                gap: spaces.spacingXs
                            }
                        ]}
                    >
                        <Card.Title
                            style={stylesheet.centered}
                        >
                            {t("blocks.login01.title")}
                        </Card.Title>
                        <Card.Description
                            style={stylesheet.centered}
                        >
                            {t("blocks.login01.description")}
                        </Card.Description>
                    </View>
                </View>
            </Card.Header>
            <Card.Content>
                <View
                    style={[
                        stylesheet.column,
                        {
                            gap: spaces.spacingLg
                        }
                    ]}
                >
                    <View
                        style={[
                            stylesheet.column,
                            {
                                gap: spaces.spacingSm
                            }
                        ]}
                    >
                        {renderProvider(t("blocks.login01.google"), GoogleColorBrandIcon)}
                        {renderProvider(t("blocks.login01.apple"), AppleBrandIcon)}
                        {renderProvider(t("blocks.login01.github"), GitHubBrandIcon)}
                    </View>
                    <Separator
                        title={t("blocks.login01.or")}
                        isShowTitle={true}
                    />
                    <View
                        style={[
                            stylesheet.column,
                            {
                                gap: spaces.spacingMd
                            }
                        ]}
                    >
                        <TextInput
                            placeholder={t("blocks.login01.emailPlaceholder")}
                            defaultValue={t("blocks.login01.emailValue")}
                            title={t("blocks.login01.email")}
                            keyboardType="email-address"
                            spreadBehaviour="stretch"
                            autoComplete="email"
                            inputMode="email"
                        />
                        <View
                            style={[
                                stylesheet.column,
                                {
                                    gap: spaces.spacingXs
                                }
                            ]}
                        >
                            <TextInput
                                defaultValue={t("blocks.login01.passwordValue")}
                                title={t("blocks.login01.password")}
                                autoComplete="current-password"
                                isShowHideTextButton={true}
                                spreadBehaviour="stretch"
                                variant="hidden"
                            />
                            <View
                                style={stylesheet.forgotRow}
                            >
                                <Button
                                    title={t("blocks.login01.forgot")}
                                    spreadBehaviour="free"
                                    onPress={handlePress}
                                    variant="link"
                                    type="neutral"
                                    size="small"
                                />
                            </View>
                        </View>
                        <CheckBox
                            title={t("blocks.login01.remember")}
                            onPress={handleRememberPress}
                            isChecked={isRemembered}
                        />
                        <Button
                            title={t("blocks.login01.submit")}
                            spreadBehaviour="stretch"
                            onPress={handlePress}
                            variant="filled"
                            type="primary"
                        />
                    </View>
                    <View
                        style={[
                            stylesheet.inline,
                            {
                                gap: spaces.spacingXs
                            }
                        ]}
                    >
                        <Text
                            variant="bodyMediumSize"
                            color="mid"
                        >
                            {t("blocks.login01.noAccount")}
                        </Text>
                        <Button
                            title={t("blocks.login01.signUp")}
                            spreadBehaviour="free"
                            onPress={handlePress}
                            variant="link"
                            type="primary"
                        />
                    </View>
                </View>
            </Card.Content>
        </Card>
        <View
            style={[
                stylesheet.heading,
                stylesheet.footer,
                {
                    maxWidth: shapeConfigs.cardWidth,
                    gap: spaces.spacingXs
                }
            ]}
        >
            <Text
                style={stylesheet.centered}
                variant="bodySmallSize"
                color="mid"
            >
                {t("blocks.login01.legalStart")}
                <Text
                    accessibilityRole="link"
                    style={stylesheet.link}
                    variant="bodySmallSize"
                    onPress={handlePress}
                    color="high"
                >
                    {t("blocks.login01.terms")}
                </Text>
                {t("blocks.login01.and")}
                <Text
                    accessibilityRole="link"
                    style={stylesheet.link}
                    variant="bodySmallSize"
                    onPress={handlePress}
                    color="high"
                >
                    {t("blocks.login01.privacy")}
                </Text>
                {t("blocks.login01.legalEnd")}
            </Text>
        </View>
    </View>;
};
export default Login01;
